import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import get from 'get-value';
import {FormattedMessage} from 'react-intl';
import {moduleRoles} from '../../../utils/roles';
import WorkingHoursContainer from './WorkingHoursContainer';
import {storeSelectedCountryGroup} from '../../../actions/admin/actionAdminWorkingHours';
import SelectCountryGroup from '../../common/country/SelectCountryGroup';
import workingHoursMessages from '../../../intl/admin/workingHoursMessages';
import PageHeader from '../../common/PageHeader';
import ImportersTable from '../../common/ImportersTable';

const Label = styled.label`
    font-weight: bold;
`;

const StyledForm = styled.form`
    padding-top: 5px;
    position: relative;
    margin: 0 auto;
`;

class WorkingHoursPage extends Component {
    componentDidMount() {
        const {domain, roles, selectedCountryGroup} = this.props;
        const groups = moduleRoles.getAdminGroups(domain, roles);
        if (selectedCountryGroup === '' || !groups.map(group => group.group).includes(selectedCountryGroup)) {
            this.props.storeSelectedCountryGroup(get(groups, '0.group', ''));
        }
    }

    handleCountryGroupSelection = countryGroup => this.props.storeSelectedCountryGroup(countryGroup.value);

    render() {
        const {domain, roles, selectedCountryGroup} = this.props;
        const groups = moduleRoles.getAdminGroups(domain, roles);
        return (
            <div>
                <PageHeader title={<FormattedMessage {...workingHoursMessages.TITLE}/>}/>
                <StyledForm className="form-group">
                    <div className="form-row mb-sm-3">
                        <div className="col-xl-2 col-lg-4 col-md-5 col-sm-6">
                            <Label>
                                <FormattedMessage {...workingHoursMessages.SELECT_COUNTRY}/>
                            </Label>
                            <SelectCountryGroup groups={groups}
                                                handleCountryGroupSelection={this.handleCountryGroupSelection}
                                                selectedCountryGroup={selectedCountryGroup}/>
                        </div>
                    </div>
                </StyledForm>
                {groups.map((group, index) =>
                    (selectedCountryGroup === group.group &&
                        <div key={index}>
                            <WorkingHoursContainer domain={domain} group={group.group}/>
                        </div>
                    )
                )}
                {selectedCountryGroup && ['IMP', 'IAG', 'IEU', 'IIN'].includes(selectedCountryGroup) && <ImportersTable importerGroups={[selectedCountryGroup]}/>}
            </div>
        );
    }
}

WorkingHoursPage.propTypes = {
    domain: PropTypes.string.isRequired,
    roles: PropTypes.object.isRequired,
    storeSelectedCountryGroup: PropTypes.func.isRequired,
    selectedCountryGroup: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    roles: state.profile.userDetail.roles,
    selectedCountryGroup: state.adminWorkingHours.selectedCountryGroup
});

export default connect(mapStateToProps, {
    storeSelectedCountryGroup
})(WorkingHoursPage);
